import { render, staticRenderFns } from "./de_table.vue?vue&type=template&id=19cb6a3e&"
import script from "./de_table.vue?vue&type=script&lang=js&"
export * from "./de_table.vue?vue&type=script&lang=js&"
import style0 from "./de_table.vue?vue&type=style&index=0&id=19cb6a3e&prod&scpoed=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports